export function isProspectInvitePath(pathname: string) {
	return pathname.startsWith("/prospect-invite/");
}
